var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AInput',{attrs:{"placehoder":"مقدار"},on:{"change":_vm.search,"pressEnter":() => _vm.search()},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }